<form class="audit-filter-form" [formGroup]="auditFilterForm" novalidate>

  <mat-form-field class="audit-edit-form--audit-type-id">
    <mat-select placeholder="Audit Type"
                formControlName="auditTypeId"
                multiple>
      <mat-option *ngFor="let auditType of auditTypes$ | async" [value]="auditType.id">
        {{ auditType.auditType }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="audit-filter-form--status">
    <mat-select placeholder="Audit Status"
                formControlName="status"
                multiple>
      <mat-option *ngFor="let s of status" [value]="s">
        {{ s }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="audit-filter-form--date-type">
    <mat-select placeholder="Date Type"
                formControlName="dateType">
      <mat-option [value]="">
        -clear-
      </mat-option>
      <mat-option *ngFor="let dateType of dateTypes" [value]="dateType">
        {{ dateType }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="audit-filter-form--date">
    <input matInput
           formControlName="date"
           placeholder="Date"
           [matDatepicker]="dateDatePicker"
           readonly/>
    <mat-datepicker-toggle matSuffix [for]="dateDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #dateDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="audit-filter-form--sme">
    <mat-select placeholder="Subject Matter Experts (SMEs)"
                formControlName="sme"
                multiple>
      <mat-option *ngFor="let s of sme$ | async" [value]="s.id">
        {{ s.fullName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="audit-filter-form--owner">
    <mat-select placeholder="Audit Owner Group"
                formControlName="ownerId"
                multiple>
      <mat-option *ngFor="let o of auditOwnerGroups$ | async" [value]="o.id">
        {{ o.auditOwnerGroup }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="audit-edit-form--external">
    <input matInput
           placeholder="External Partner"
           formControlName="external"/>
  </mat-form-field>

  <div class="audit-filter-form--activity">
    <mat-list>
      <mat-list-item> CAPA/EC Activitiy Status </mat-list-item>
      <mat-list-item> <mat-checkbox formControlName="capaInProgress">In Progress</mat-checkbox> </mat-list-item>
      <mat-list-item><mat-checkbox  formControlName="capaOverdue">Overdue</mat-checkbox> </mat-list-item>
      <mat-list-item><mat-checkbox  formControlName="capaCompleted">Completed</mat-checkbox> </mat-list-item>
     </mat-list>
  </div>
</form>
